/**
 * @module
 *
 * @import {Amateur} from '../../amateurPool/model/amateur';
 * @import {ctxAmateur} from '../../amateurPool/context/amateur';
 * @import {ctxAuthUser} from '../../userPool/context/auth-user';
 */

import {PREFIX_ACTIVE, PREFIX_DISABLED, PREFIX_INACTIVE, SwapClass} from '../../layout/service/style.js';
import {checkPin} from './cache.js';
import {name} from './template.js';

/**
 * The {@link ctxAmateur | local amateur} is pinned.
 *
 * @group CSS Class
 */
export const PIN_ACTIVE = `${PREFIX_ACTIVE}${name}`;

/**
 * The {@link ctxAmateur | local amateur} is not pinned.
 *
 * @group CSS Class
 */
export const PIN_INACTIVE = `${PREFIX_INACTIVE}${name}`;

/**
 * The pin state of the {@link ctxAmateur | local amateur} is not determined,
 * which may be the result of one of the following reasons:
 *
 * - The _pin_ feature is initializing.
 * - The _pin_ feature is hidden for the {@link ctxAuthUser | user}.
 * - The _pin_ feature is hidden for the {@link Amateur | amateur}.
 *
 * @group CSS Class
 */
export const PIN_DISABLED = `${PREFIX_DISABLED}${name}`;

const swap = SwapClass([PIN_ACTIVE], [PIN_INACTIVE], [PIN_DISABLED]);

/**
 * @param {Element} element
 * @param {Amateur | null} amateur
 *
 * @returns {void}
 */
export const toggle = (element, amateur) => swap(element, checkPin(amateur));
